// extracted by mini-css-extract-plugin
export default {"gallery":"Gallery_gallery__6qYzB","galleryItem":"Gallery_galleryItem__qkE8d","galleryImage":"Gallery_galleryImage__1y4ij","caption":"Gallery_caption__dAGYy"};